<template>
  <div
    ref="kt_modal_view_file_pdf"
    data-bs-backdrop="static"
    data-bs-focus="false"
    class="modal fade modal-overlay"
    tabindex="-1"
    id="kt_modal_view_file_pdf"
    data-bs-keyboard="false"
  >
    <div
      class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="p-2 bg-light">
          <div class="d-flex flex-wrap gap-1">
            <button
              type="button"
              class="btn btn-sm btn-active-secondary"
              @click="this.$refs.pdfViewer.print()"
            >
              <i class="fas fa-print fs-4 p-0"></i>
              <span class="align-middle d-flex mt-2">Imprimir</span>
            </button>
            <button
              type="button"
              class="btn btn-sm btn-active-secondary"
              @click="enviarEmail()"
            >
              <i class="fas fa-envelope fs-4 p-0"></i>
              <span class="align-middle d-flex mt-2">Email</span>
            </button>
            <button
              type="button"
              class="btn btn-sm btn-active-secondary"
              @click="download()"
            >
              <i class="fas fa-download fs-4 p-0"></i>
              <span class="align-middle d-flex mt-2">Download</span>
            </button>
            <button
              type="button"
              class="btn btn-sm btn-active-secondary"
              @click="compartilhar()"
            >
              <i class="fas fa-share fs-4 p-0"></i>
              <span class="align-middle d-flex mt-2">Compartilhar</span>
            </button>
            <button
              type="button"
              class="btn btn-sm btn-active-secondary btn-icon-danger btn-text-danger"
              @click="fechar()"
            >
              <i class="fas fa-times fs-4 p-0"></i>
              <span class="align-middle d-flex mt-2">Fechar</span>
            </button>
          </div>
        </div>
        <!-- <div class="modal-header p-2 bg-light">
          
        </div> -->
        <div class="modal-body p-0">
          <div
            v-if="isLoading"
            class="m-10 d-flex justify-content-center"
            v-bind:data-kt-indicator="isLoading ? 'on' : 'off'"
          >
            <span class="indicator-progress">
              Aguarde, carregando...
              <span
                class="spinner-border spinner-border-sm align-middle ms-2"
              ></span>
            </span>
          </div>
          <vue-pdf-embed
            class="ms-5 me-5"
            v-else
            ref="pdfViewer"
            :width="width"
            :source="pdf"
          />
        </div>
        <div class="modal-footer p-0">
          <div class="d-flex flex-wrap gap-1">
            <button
              type="button"
              class="btn btn-sm btn-active-secondary"
              @click="zoom(100)"
            >
              <i class="fas fa-search-plus fs-4 p-0"></i>
            </button>
            <button
              type="button"
              class="btn btn-sm btn-active-secondary"
              @click="zoom(-100)"
            >
              <i class="fas fa-search-minus fs-4 p-0"></i>
            </button>
            <button
              type="button"
              class="btn btn-sm btn-active-secondary"
              @click="zoom(undefined)"
            >
              <i class="fas fa-file-alt fs-4 p-0"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <SendMailModal
    v-if="exibirModalEmail"
    :show="exibirModalEmail"
    :emails="emails"
    :assunto="assuntoEmail"
    :mensagem="mensagemEmail"
    :anexos="anexosEmail"
    @exibirModalMail="exibirModalMail"
  ></SendMailModal>
</template>

<script>
import { hideModal, getOrCreateInstanceModal } from "@/core/helpers/dom";
import SendMailModal from "@/components/modals/general/SendMailModal";
import VuePdfEmbed from "vue-pdf-embed";
import Swal from "sweetalert2/dist/sweetalert2.min.js";

export default {
  emits: ["exibirModalImpressao"],
  components: {
    VuePdfEmbed,
    SendMailModal,
  },
  props: {
    show: { type: Boolean, required: true },
    documento: { type: Object, required: true },
    dadosEmail: { type: Object, required: false },
  },
  async mounted() {
    this.nome = this.$utils.generateUuidv4();
    this.isLoading = true;
    if (this.documento.FileContents) {
      let blob = this.$utils.dataToBlob(this.documento);
      await this.$utils.blobToBase64(blob).then((res) => {
        setTimeout(() => {
          this.pdf = res;
          this.isLoading = false;
        }, 500);
      });
    } else {
      await this.$utils.blobToBase64(this.documento).then((res) => {
        setTimeout(() => {
          this.pdf = res;
          this.isLoading = false;
        }, 500);
      });
    }
  },
  methods: {
    async download() {
      var fileURL = [];
      if (this.documento.FileContents) {
        let blob = this.$utils.dataToBlob(this.documento);
        fileURL = window.URL.createObjectURL(new Blob([blob]), {
          type: "application/pdf",
        });
      } else {
        fileURL = window.URL.createObjectURL(new Blob([this.documento]), {
          type: "application/pdf",
        });
      }
      var fileLink = document.createElement("a");
      fileLink.href = fileURL;
      fileLink.setAttribute("download", this.nome + ".pdf");
      document.body.appendChild(fileLink);
      fileLink.click();
    },
    async enviarEmail() {
      // this.emails = ["guilherme@gatewaysistemas.com.br"];
      // this.assuntoEmail = "Pedido de venda ";
      // this.mensagemEmail =
      //   "<H2>Prezado cliente,</H2><br/><br/>Segue anexo o pedido de venda.";
      // this.anexosEmail = [{ nome: "Pedido.pdf", base64Arquivo: this.pdf }];
      if (this.dadosEmail && this.dadosEmail !== null) {
        this.emails = this.dadosEmail.emails;
        this.assuntoEmail = this.dadosEmail.assuntoEmail;
        this.mensagemEmail = this.dadosEmail.mensagemEmail;
        this.anexosEmail = this.dadosEmail.anexosEmail;
      } else {
        this.emails = [];
        this.assuntoEmail = "";
        this.mensagemEmail = "";
        this.anexosEmail = [];
      }
      this.exibirModalMail(true);
    },
    async compartilhar() {
      try {
        var fileURL = [];
        if (this.documento.FileContents) {
          let blob = this.$utils.dataToBlob(this.documento);
          fileURL = window.URL.createObjectURL(new Blob([blob]), {
            type: "application/pdf",
          });
          const pdfFile = new File([blob], this.nome + ".pdf", {
            type: "application/pdf",
          });

          if (navigator.share) {
            // Compartilhar o PDF usando a API navigator.share()
            await navigator.share({
              files: [pdfFile],
            });
          } else {
            // Se a API navigator.share() não for suportada, mostrar uma mensagem de erro ou oferecer uma alternativa
            console.error(
              "A API navigator.share() não é suportada neste navegador."
            );
          }
        } else {
          const pdfFile = new File(this.documento, this.nome + ".pdf", {
            type: "application/pdf",
          });

          if (navigator.share) {
            // Compartilhar o PDF usando a API navigator.share()
            await navigator.share({
              files: [pdfFile],
            });
          } else {
            //alert("A API navigator.share()");
            // Se a API navigator.share() não for suportada, mostrar uma mensagem de erro ou oferecer uma alternativa
            console.error(
              "A API navigator.share() não é suportada neste navegador."
            );
          }
        }
      } catch (error) {
        //alert(error);
        console.error("Erro ao compartilhar PDF:", error);
      }
    },

    blobToFile(blob) {
      return new Promise((resolve, reject) => {
        try {
          const xhr = new XMLHttpRequest();
          xhr.open("GET", blob, true);
          xhr.responseType = "blob";
          xhr.onload = function () {
            if (this.status === 200) {
              const blobFile = this.response;
              // Extrair o nome do arquivo do URL
              const fileName = blob.substring(blob.lastIndexOf("/") + 1);
              // Criar um objeto File a partir do blob
              const file = new File([blobFile], fileName, {
                type: "application/pdf",
              });
              resolve(file);
            } else {
              reject(new Error("Erro ao converter blob para arquivo."));
            }
          };
          xhr.onerror = function () {
            reject(new Error("Erro ao carregar blob."));
          };
          xhr.send();
        } catch (error) {
          reject(error);
        }
      });
    },
    async share() {
      //window.open("https://api.whatsapp.com/send?text=Pedido");

      let fileURL = [];
      if (this.documento.FileContents) {
        let blob = this.$utils.dataToBlob(this.documento);
        fileURL = window.URL.createObjectURL(new Blob([blob]));
      } else {
        fileURL = window.URL.createObjectURL(new Blob([this.documento]));
      }
      let mensagem = "";
      if (this.dadosEmail && this.dadosEmail !== null) {
        mensagem = this.dadosEmail.assuntoEmail;
      }
      const whatsappURL = `whatsapp://send?text=${mensagem}&file=${fileURL}`;
      window.location.href = whatsappURL;

      // var mensagem = {
      //   emails: [],
      //   celular: "5515997413886",
      //   titulo: "",
      //   mensagem: "",
      //   anexos: [{ nome: "Pedido.pdf", base64Arquivo: this.pdf }],
      // };

      // try {
      //   var response = await this.$store.dispatch(
      //     "compartilhamento/whatsapp",
      //     mensagem
      //   );
      //   if (response.Success === true) {
      //   }
      // } catch (error) {
      //   console.log(error);
      //   });
      // }
    },
    async exibirModalMail(exibir) {
      this.exibirModalEmail = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_send_mail",
          /*open*/ () => {
            this.$utils.requestFocus("kt_modal_send_mail");
          },
          /*close*/ () => {
            this.exibirModalMail(false);
          }
        );
      }
    },
    async zoom(valor) {
      if (this.width === undefined) {
        this.width =
          this.$refs.kt_modal_view_file_pdf.getBoundingClientRect().width;
      }

      this.width += parseInt(valor);
      if (this.width <= 0) {
        this.width = undefined;
      }

      if (valor === undefined) {
        this.width = undefined;
      }
    },
    async fechar() {
      hideModal(this.$refs.kt_modal_view_file_pdf);
      this.$emit("exibirModalImpressao", false);
    },
  },
  data() {
    return {
      pdf: [],
      isLoading: true,
      width: undefined,
      nome: "",
      exibirModalEmail: false,
      emails: [],
      assuntoEmail: "",
      mensagemEmail: "",
      anexosEmail: [],
    };
  },
};
</script>

<style></style>
